import React from "react";
import Layout from "../components/Layout";
import ProductCard from "../components/ProductCard";
import styles from "./Atlantic.module.css";
import { useLanguage } from "../i18n/LanguageContext";

const cucumberProducts = [
  {
    key: "cornichons480",
    image: "/assets/products/vegetables/cucumbers/valmis-marinated-cornichons-3-6-480.png",
  },
  {
    key: "cornichons680",
    image: "/assets/products/vegetables/cucumbers/valmis-marinated-cornichons-3-6-680.png",
  },
  {
    key: "gherkins680",
    image: "/assets/products/vegetables/cucumbers/valmis-marinated-gherkins-6-9-680.png",
  },
];

const Cucumbers = () => {
  const { t } = useLanguage();

  return (
    <Layout>
      <h2 className={styles.heading}>{t("vegetables.cucumbers.title")}</h2>

      <div className={styles.grid}>
        {cucumberProducts.map((product) => (
          <ProductCard
            key={product.key}
            title={t(`vegetables.products.cucumbers.${product.key}.title`)}
            weight={t(`vegetables.products.cucumbers.${product.key}.weight`)}
            description={t(`vegetables.products.cucumbers.${product.key}.description`)}
            image={product.image}
          />
        ))}
      </div>
    </Layout>
  );
};

export default Cucumbers;
